export async function withRetries<T>(fn: () => Promise<T>, retries = 3): Promise<T> {

  let last_error: Error | null = null;

  for (let i = 0; i < retries; i++) {
    try {
      return await fn();
    } catch (err: any) {
      last_error = err;
    }
  }

  throw last_error;
}
